export default async function (ctx, inject) {
  const icons = {"192x192":"/_nuxt/icons/icon_192.c889d0.png","512x512":"/_nuxt/icons/icon_512.c889d0.png"}
  const getIcon = size => icons[size + 'x' + size] || ''
  inject('icon', getIcon)
}
